export default __webpack_public_path__ + "static/media/image-fake.cbec010d.png";